import { createSvgIcon } from '@mui/material/utils';

export const PersonIcon = createSvgIcon(
    <>
        <path d='M 12 0 C 8.994 0 6.557 2.445 6.557 5.461 C 6.557 8.477 8.994 10.922 12 10.922 C 15.006 10.922 17.443 8.477 17.443 5.461 C 17.443 2.445 15.006 0 12 0 Z' />
        <path d='M 6.193 13.836 C 3.187 13.836 0.75 16.281 0.75 19.297 L 0.75 21.028 C 0.75 22.125 1.542 23.06 2.621 23.237 C 8.833 24.254 15.167 24.254 21.378 23.237 C 22.458 23.06 23.25 22.125 23.25 21.028 L 23.25 19.297 C 23.25 16.281 20.813 13.836 17.807 13.836 L 17.312 13.836 C 17.044 13.836 16.778 13.878 16.523 13.962 L 15.267 14.373 C 13.144 15.069 10.856 15.069 8.733 14.373 L 7.477 13.962 C 7.222 13.878 6.956 13.836 6.688 13.836 L 6.193 13.836 Z' />
    </>,
    'PersonIcon'
);
